export default __webpack_public_path__ + "static/media/tv-icon.dd055e8d.svg";